import { render, staticRenderFns } from "./formBox.vue?vue&type=template&id=20bd7595&scoped=true"
import script from "./formBox.vue?vue&type=script&lang=js"
export * from "./formBox.vue?vue&type=script&lang=js"
import style0 from "./formBox.vue?vue&type=style&index=0&id=20bd7595&scoped=true&lang=scss"
import style1 from "./formBox.vue?vue&type=style&index=1&id=20bd7595&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bd7595",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20bd7595')) {
      api.createRecord('20bd7595', component.options)
    } else {
      api.reload('20bd7595', component.options)
    }
    module.hot.accept("./formBox.vue?vue&type=template&id=20bd7595&scoped=true", function () {
      api.rerender('20bd7595', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/develop/module/components/formBox.vue"
export default component.exports